import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogSelectorIconoComponent } from './dialog-selector-icono/dialog-selector-icono.component';
import { ICONO_POR_DEFECTO } from './iconos-disponibles';

/**
 * Campo para elegir un icono.
 *
 * Implementa ControlValueAccessor para poder usarse igual que cualquier input
 * del formulario:
 *
 *   <app-selector-icono formControlName="Icono" etiqueta="Icono del tipo">
 *   </app-selector-icono>
 *
 * El valor que guarda es el nombre de la ligature de Material Icons, que es lo
 * que después consume <mat-icon>.
 */
@Component({
  selector: 'app-selector-icono',
  templateUrl: './selector-icono.component.html',
  styleUrls: ['./selector-icono.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectorIconoComponent),
      multi: true
    }
  ]
})
export class SelectorIconoComponent implements ControlValueAccessor {

  @Input() etiqueta: string = 'Icono'

  /** Texto de ayuda debajo del campo */
  @Input() ayuda: string = ''

  icono: string | null = null
  deshabilitado = false

  readonly iconoPorDefecto = ICONO_POR_DEFECTO

  private alCambiar: (valor: string | null) => void = () => { }
  private alTocar: () => void = () => { }

  constructor(private dialog: MatDialog) { }

  // ---------- ControlValueAccessor ----------

  writeValue(valor: string | null): void {
    this.icono = valor ? valor : null
  }

  registerOnChange(fn: (valor: string | null) => void): void {
    this.alCambiar = fn
  }

  registerOnTouched(fn: () => void): void {
    this.alTocar = fn
  }

  setDisabledState(deshabilitado: boolean): void {
    this.deshabilitado = deshabilitado
  }

  // ---------- Interacción ----------

  abrirSelector() {
    if (this.deshabilitado)
      return

    const dialogRef = this.dialog.open(DialogSelectorIconoComponent, {
      width: '640px',
      maxWidth: '95vw',
      autoFocus: false,
      data: { iconoActual: this.icono, titulo: 'Elegir ' + this.etiqueta.toLowerCase() }
    })

    dialogRef.afterClosed().subscribe(resultado => {
      this.alTocar()

      // undefined = canceló. null = eligió "Sin icono". Son cosas distintas y
      // por eso no alcanza con un chequeo de verdad/falsedad.
      if (!resultado)
        return

      this.icono = resultado.icono ? resultado.icono : null
      this.alCambiar(this.icono)
    })
  }

  quitar(evento: Event) {
    evento.stopPropagation()

    if (this.deshabilitado)
      return

    this.icono = null
    this.alCambiar(null)
    this.alTocar()
  }
}
